const $ = jQuery.noConflict();

class RequestInfoForm {
	constructor() {
		this.buttonToClick = $('.js-request-info-main-button');
		this.requestButton = $('.js-request-more-info');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.requestButton.on('click', this.openForm);
	}
	openForm() {
		$('.js-request-info-main-button').trigger('click');
	}
}

const newRequestInfoForm = new RequestInfoForm();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newRequestInfoForm.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
